var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,506.8C117.7,506.8,5.2,394.3,5.2,256S117.7,5.2,256,5.2S506.8,117.7,506.8,256S394.3,506.8,256,506.8z  M256,46C140.2,46,46,140.2,46,256s94.2,210,210,210s210-94.2,210-210S371.8,46,256,46z M256,383.9c-103.3,0-139.6-69.7-141.1-72.7 c-5-10.1-0.9-22.3,9.1-27.3c2.9-1.4,5.9-2.2,9.1-2.2c7.7,0,14.7,4.3,18.2,11.2c1,2,27.1,50.3,104.7,50.3 c77.5,0,103.7-48.3,104.8-50.4c3.5-6.8,10.5-11,18.1-11c3.2,0,6.4,0.8,9.2,2.2c9.9,5,13.9,17.2,9,27.2 C395.6,314.2,359.3,383.9,256,383.9z M332.8,230.3c-19.7,0-35.7-16-35.7-35.7c0-19.7,16-35.7,35.7-35.7s35.7,16,35.7,35.7 C368.5,214.3,352.5,230.3,332.8,230.3z M179.2,230.3c-19.7,0-35.7-16-35.7-35.7c0-19.7,16-35.7,35.7-35.7c19.7,0,35.7,16,35.7,35.7 C214.9,214.3,198.9,230.3,179.2,230.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.1e68aa4f9f068c86cd64c3fec1a68434.svg";
export { ForwardRef as ReactComponent };